import React from "react";
import { Modal, Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { MapContainer, TileLayer, GeoJSON  } from 'react-leaflet'
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapSigns, faPlus, faSave, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
const FormData = ({
    show,
    handleClose,
    formAttribute,
    handleChange,
    handleChangeFormArray,
    handleSubmit,
    isLoading,
    validate,
    addRoutePoint,
    removeRoutePoint,
    generateMapRoute,
    defaultLongLat,
    routeGeoJSON
}) => {
    const { title, data } = formAttribute;
    const geoJsonData = {
        type: "FeatureCollection",
        features: [
            {
                type: "Feature",
                properties: { name: "Rute Contoh" },
                geometry: {
                    type: "LineString",
                    coordinates: routeGeoJSON ? routeGeoJSON : []
                }
            }
        ]
    };
    console.log(geoJsonData);
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">{title}</Modal.Title>
                <FalconCloseButton onClick={handleClose} variant="white"/>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validate} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formGroupKode">
                        <Form.Label>Kode</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={data?.vckode} 
                            onChange={(event) => handleChange(event)} 
                            name="vckode" 
                            placeholder="Kode"
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Kode tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNama">
                        <Form.Label>Nama</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcnama}
                            onChange={(event) => handleChange(event)}
                            name="vcnama"
                            placeholder="Nama" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nama tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    {
                        data?.titik_rute ? data?.titik_rute.map((value, index) => {
                            return (
                                <Row className="mb-3 g-3" key={index}>
                                    <Form.Group as={Col} controlId="vcRoutePoint">
                                        <Form.Label>Titik Rute</Form.Label>
                                        <Form.Control 
                                            required
                                            type="text" 
                                            placeholder="Titik Rute" 
                                            name="vcnama" 
                                            value={value.vcnama} 
                                            onChange={(e) => handleChangeFormArray(e, index, 'titik_rute')} />
                                        <Form.Control.Feedback type="invalid">
                                            Titik Rute tidak boleh kosong.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="decLatitude">
                                        <Form.Label>Koordinat Latitude</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            placeholder="Koordinat Latitude" 
                                            name="declattitude" 
                                            value={value.declattitude}
                                            onChange={(e) => handleChangeFormArray(e, index, 'titik_rute')} />
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="decLongitude">
                                        <Form.Label>Koordinat Longitude</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            placeholder="Koordinat Longitude" 
                                            name="declongitude" 
                                            value={value.declongitude}
                                            onChange={(e) => handleChangeFormArray(e, index, 'titik_rute')} />
                                    </Form.Group>

                                    <Col xs={1}>
                                        <Form.Group controlId="decLongitude">
                                            <Form.Label>&nbsp;</Form.Label>
                                            <Button variant="danger" onClick={() => removeRoutePoint(index)}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )
                        }) : ''
                    }
                    
                    <Row className="mb-3 g-3 justify-content-md-center">
                        <Col lg={4} className="d-grid">
                            <Button onClick={addRoutePoint}>
                                <FontAwesomeIcon icon={faPlus} /> Tambah Titik Rute
                            </Button>
                        </Col>
                    </Row>
                    
                    <Row className="mb-3 g-3 justify-content-md-center">
                        <Col lg={4} className="d-grid">
                            <Button onClick={generateMapRoute} variant="warning">
                                {isLoading ? (<>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    Generate...
                                </>
                                ) : (<>
                                    <FontAwesomeIcon icon={faMapSigns} /> Generate Rute
                                </>) }
                            </Button>
                        </Col>
                    </Row>
                    
                    <Row className="mb-3 g-3 justify-content-md-center">
                        <Col lg={12} className="d-grid">
                            <MapContainer center={defaultLongLat} zoom={14} scrollWheelZoom={false} style={{width:'100%', height: '100v'}}>
                                <TileLayer
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                <GeoJSON data={geoJsonData} style={{ color: 'blue', weight: 5 }} />
                            </MapContainer>
                        </Col>
                    </Row>
                    
                    <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                    </Button>
                    <Button disabled={isLoading} type="submit" className="float-end">
                        {isLoading ? (<>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </>
                        ) : (<>
                            <FontAwesomeIcon icon={faSave} className="me-2" />
                            Simpan
                        </>) }
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

FormData.propTypes = {}

export default FormData;